<!-- <div [formGroup]="form">
  <label [attr.for]="control.key">{{ control.label }}</label>

  <div [ngSwitch]="control.controlType">
    <input
      *ngSwitchCase="'textbox'"
      [formControlName]="control.key"
      [id]="control.key"
      [type]="control.type"
    />

    <select
      [id]="control.key"
      *ngSwitchCase="'dropdown'"
      [formControlName]="control.key"
    >
      <option *ngFor="let opt of control.options" [value]="opt.key">
        {{ opt.value }}
      </option>
    </select>
  </div>

  <div class="errorMessage" *ngIf="!isValid">
    {{ control.label }} is required
  </div>
</div> -->

<div [formGroup]="form">
  <ng-container [ngSwitch]="control.controlType">
    <!-- textbox -->
    <mat-form-field
    color="accent" appearance="outline"
      class="full-width-field"
      *ngSwitchCase="'textbox'"
      [ng-hide]="control.hidden"
    >
      <mat-label>{{ control.label }}</mat-label>
      <input
        matInput
        [maxlength]="control.maxLength"
        [formControlName]="control.key"
        [id]="control.key"
        [type]="control.type"
      />

      <mat-error>Este campo es obligatorio.</mat-error>
    </mat-form-field>

    <!-- dropdown -->
    <mat-form-field color="accent" appearance="outline" *ngSwitchCase="'dropdown'">
      <mat-label>{{ control.label }}</mat-label>
      <mat-select [formControlName]="control.key" [id]="control.key">
        <mat-option *ngFor="let opt of control.options" [value]="opt.key">
          {{ opt.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- datepicker -->
    <mat-form-field  color="accent" appearance="outline" *ngSwitchCase="'datepicker'">
      <mat-label>{{ control.label }}</mat-label>
      <input
        matInput
        [id]="control.key"
        [matDatepicker]="picker"
        [formControlName]="control.key"
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <!-- Chekbox -->
      <mat-checkbox *ngSwitchCase="'checkbox'"
                    [id]="control.key"
                    [formControlName]="control.key">{{ control.label }}</mat-checkbox>
  </ng-container>
</div>
